export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";